/*
 * NYORD: Showroom-Effekt für die Kartenreihen (.nb-tabs--buehne .nb-tabs__raster) auf dem Handy. Je Karte der
 * Abstand zur Mitte in Kartenbreiten als --n (0 … 1,5) und die Richtung als --s; das CSS verkleinert, dreht und
 * dimmt danach die Nachbarn. Auf breiten Bildschirmen (Raster) passiert nichts.
 */
(function () {
  var handy = window.matchMedia('(max-width: 749px)');
  var geplant = new Set();
  var raf = null;

  function zeichnen(raster) {
    var karten = raster.children;
    if (!handy.matches || !raster.offsetParent) {
      for (var j = 0; j < karten.length; j++) karten[j].style.removeProperty('--n');
      return;
    }
    var box = raster.getBoundingClientRect();
    var mitte = box.left + box.width / 2;
    for (var i = 0; i < karten.length; i++) {
      var r = karten[i].getBoundingClientRect();
      var abstand = (r.left + r.width / 2 - mitte) / r.width;
      karten[i].style.setProperty('--n', Math.min(Math.abs(abstand), 1.5).toFixed(3));
      karten[i].style.setProperty('--s', abstand < 0 ? -1 : 1);
    }
  }

  function planen(raster) {
    geplant.add(raster);
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      geplant.forEach(zeichnen);
      geplant.clear();
    });
  }

  function alle() {
    document.querySelectorAll('.nb-tabs--buehne .nb-tabs__raster').forEach(planen);
  }

  function verbinden(raster) {
    if (raster.dataset.nbBuehne) return;
    raster.dataset.nbBuehne = '1';
    raster.addEventListener('scroll', function () {
      planen(raster);
    }, { passive: true });
    // „Zuletzt angesehen“ füllt seine Reihe erst nachträglich
    new MutationObserver(function () {
      planen(raster);
    }).observe(raster, { childList: true });
    planen(raster);
  }

  // Auch für Reihen, die später ins DOM kommen (sections/nb-empfehlungen lädt seine Karten nach)
  window.nbBuehneAlle = function () {
    document.querySelectorAll('.nb-tabs--buehne .nb-tabs__raster').forEach(verbinden);
    alle();
  };

  function start() {
    document.querySelectorAll('.nb-tabs--buehne .nb-tabs__raster').forEach(verbinden);
    // Reiterwechsel macht eine andere Reihe sichtbar
    document.addEventListener('click', function (e) {
      if (e.target.closest('.nb-tabs__reiter')) setTimeout(alle, 30);
    });
    window.addEventListener('resize', alle);
    if (handy.addEventListener) handy.addEventListener('change', alle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
